import { t } from "@lingui/macro";
import * as React from "react";
import {
  ClipPath,
  Defs,
  Filter,
  G,
  LinearGradient,
  Path,
  Rect,
  Stop,
  FeBlend,
  FeFlood,
  FeColorMatrix,
  FeOffset,
  FeComposite,
  FeGaussianBlur,
} from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const PunchPassAppliedIcon = (props: IconProps) => (
  <Icon
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    title={t`Punch Pass Applied`}
    {...props}
  >
    <G clipPath="url(#clip0_14872_39277)">
      <G filter={`url(#filter0_i_14872_39277)`}>
        <Path
          d="M0.645774 8.44096C-0.215259 9.302 -0.215257 10.698 0.645775 11.559L2.28335 13.1966V15.5122C2.28335 16.7299 3.27048 17.717 4.48816 17.717H6.80377L8.44096 19.3542C9.302 20.2153 10.698 20.2153 11.559 19.3542L13.1962 17.717H15.5122C16.7299 17.717 17.717 16.7299 17.717 15.5122V13.1962L19.3542 11.559C20.2153 10.698 20.2153 9.30199 19.3542 8.44096L17.717 6.80377V4.48816C17.717 3.27047 16.7299 2.28335 15.5122 2.28335H13.1966L11.559 0.645774C10.698 -0.215259 9.30199 -0.215257 8.44096 0.645775L6.80339 2.28335H4.48816C3.27047 2.28335 2.28335 3.27048 2.28335 4.48816V6.80339L0.645774 8.44096Z"
          fill="url(#paint0_linear_14872_39277)"
        />
      </G>
      <G filter={`url(#filter1_d_14872_39277)`}>
        <Path
          d="M13.5 6.5L6.5 13.5"
          stroke="white"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M6.80469 6.79199H6.81914"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M13.207 13.1924H13.2215"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
    </G>
    <Defs>
      <Filter
        id="filter0_i_14872_39277"
        x="0"
        y="0"
        width="20"
        height="21"
        filterUnits="userSpaceOnUse"
      >
        <FeFlood floodOpacity="0" result="BackgroundImageFix" />
        <FeBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <FeColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <FeOffset dy="1" />
        <FeGaussianBlur stdDeviation="0.5" />
        <FeComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <FeColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
        />
        <FeBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_14872_39277"
        />
      </Filter>
      <Filter
        id="filter1_d_14872_39277"
        x="4.30469"
        y="5.29199"
        width="11.4168"
        height="11.4004"
        filterUnits="userSpaceOnUse"
      >
        <FeFlood floodOpacity="0" result="BackgroundImageFix" />
        <FeColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <FeOffset dy="1" />
        <FeGaussianBlur stdDeviation="0.5" />
        <FeComposite in2="hardAlpha" operator="out" />
        <FeColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.28 0"
        />
        <FeBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_14872_39277"
        />
        <FeBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_14872_39277"
          result="shape"
        />
      </Filter>
      <LinearGradient
        id="paint0_linear_14872_39277"
        x1="10"
        y1="0"
        x2="10"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#5AC79E" />
        <Stop offset="1" stopColor="#1DAA75" />
      </LinearGradient>
      <ClipPath id="clip0_14872_39277">
        <Rect width="20" height="20" fill="white" />
      </ClipPath>
    </Defs>
  </Icon>
);
